import { Route, Routes } from 'react-router-dom'
import { AuthorizedAppsAccessLayout } from 'pages/settings/pages/developer/pages/authorizedApps/layout/AuthorizedAppsAccessLayout'
import { AuthorizedAppsPageLayout } from 'pages/settings/pages/developer/pages/authorizedApps/layout/AuthorizedAppsPageLayout'
import { AuthorizedAppsPage } from 'pages/settings/pages/developer/pages/authorizedApps/ui/authorizedAppsPage'

export const AuthorizedAppsRouter = () => {
  return (
    <Routes>
      <Route element={<AuthorizedAppsAccessLayout />}>
        <Route element={<AuthorizedAppsPageLayout />}>
          <Route path={'/'} element={<AuthorizedAppsPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
